/*
 * @Author: Tahiti
 * @Date: 2025-11-17 18:51:40
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-18 17:04:30
 * @Description:
 * @FilePath: /weryai-web/locales/modules/img2VidIntro.ts
 */
export default {
    zh: {
        title1: '让图片动起来，让创意无限可能',
        desc1: '微鲤AI 是一个完美的，一站式图片转视频 AI 平台。我们提供对所有行业领先视频模型的访问，所有这些都集中在WeryAI。无需在多个平台之间切换轻松尝试并创建令人惊叹的视觉效果，一切尽在WeryAI！',
        moreModels: '更多模型',
        showLess: '收起',
        title2: '使用WeryAI图生视频生成器为您的图像制作动画',
        desc2: '使用WeryAI将任何图像变成生动的故事！使用我们的 AI 图生视频生成器，将您上传的照片生成创意视频（带音频）。无论您想要生成逼真的场景还是动画，我们都能快速按照您的需求制作。',
        prompt: '提示词',
        title3: '使用WeryAI图生视频生成器，开启无限可能',
        desc3: '体验无限创意风格——从霓虹灯照亮的赛博朋克都市景观到令人叹为观止的自然风光等。使用我们的文生视频AI，您可以创作符合独特愿景的电影级沉浸视频。',
        getStarted: '体验我们的图生视频AI',
        title4: '强大的图生视频AI，助力创作者与企业',
        tab1: '品牌与企业家',
        intro1: '为您的品牌注入生命力，打造令人难忘的品牌故事',
        info1: '通过故事化的品牌内容，吸引受众关注并提升品牌知名度。',
        tab2: '营销人员和代理商',
        intro2: '视频制作成本降低至少60%',
        info2: '无需支付高昂的制作成本即可打造品牌内容。只需花费极低的成本，即可生成独特、惊艳的视觉效果，专业地展示您的产品/服务。',
        tab3: '电影制作人',
        intro3: '轻松生成震撼人心的电影级视频',
        info3: '无需复杂的后期制作流程，快速将创意概念转化为高质量视频。利用AI技术，大幅缩短制作周期，让您的创意想法快速落地。',
        tab4: '网红',
        intro4: '创作吸引眼球的短视频',
        info4: '快速产出高质量内容，保持账号活跃度。无需专业设备或团队，一个人即可创作出专业级的短视频内容，提升粉丝互动。',
        how_to_use_title: '如何使用WeryAI图生视频生成器',
        how_to_use_desc:
            '我们的图生视频生成器设计非常简单。只需三步即可轻松制作视频。',
        step1_title: '上传图片，输入内容并配置自定义选项。',
        step2_title: '启动我们的图生视频生成器。',
        step3_title: '查看并下载生成的视频。',
        otherVideo: '释放其他AI视频生成器的全部潜力',
        exploreTools: '探索我们先进的AI视频工具',
        join: '加入 1000 多万用户，使用WeryAI创造和启发灵感',
        startNow: '立即开始体验',
    },
    en: {
        title1: 'Meet Our All-in-One Image to Video AI',
        desc1: '微鲤AI is a perfect, all-in-one image to video AI platform. We provide access to all the industry-leading video models, all in one single place. Try them seamlessly and create stunning visuals without juggling multiple platforms!',
        moreModels: 'More Models',
        showLess: 'Show Less',
        title2: 'Use 微鲤AI Image to Video Generator to animate your images',
        desc2: 'Use 微鲤AI to turn any image into a lively story! Use our AI image to video generator to generate creative videos (with audio) from your uploaded photos. Whether you want to generate realistic scenes or animations, we can quickly create them according to your needs.',
        prompt: 'Prompt',
        title3: 'Use 微鲤AI Image to Video Generator, start your infinite possibilities',
        desc3: 'Experience infinite creative styles—from neon-lit cyberpunk cityscapes to breathtaking natural landscapes. Use our text to video AI to create cinematic immersive videos that align with your unique vision.',
        getStarted: 'Experience our Image to Video AI',
        title4: 'Powerful Image to Video AI, Empowering Creators and Businesses',
        tab1: 'Brands & Entrepreneurs',
        intro1: 'Bring your brand to life and create unforgettable brand stories',
        info1: 'Attract audience attention and enhance brand awareness through storytelling brand content.',
        tab2: 'Marketers & Agencies',
        intro2: 'Reduce video production costs by at least 60%',
        info2: 'Create brand content without paying high production costs. Generate unique and stunning visual effects at extremely low costs to professionally showcase your products/services.',
        tab3: 'Filmmakers',
        intro3: 'Easily generate stunning cinematic videos',
        info3: 'Quickly transform creative concepts into high-quality videos without complex post-production processes. Leverage AI technology to significantly shorten production cycles and bring your creative ideas to life quickly.',
        tab4: 'Influencers',
        intro4: 'Create eye-catching short videos',
        info4: 'Quickly produce high-quality content to maintain account activity. Create professional-grade short video content alone without professional equipment or teams, boosting fan engagement.',
        how_to_use_title: 'How to Use 微鲤AI Image to Video Generator',
        how_to_use_desc:
            'Our image to video generator is designed to be very simple. Create videos easily in just three steps.',
        step1_title:
            'Upload an image, enter content and configure custom options.',
        step2_title: 'Launch our image to video generator.',
        step3_title: 'View and download the generated video.',
        otherVideo: 'Unlock the full potential of other AI video generators',
        exploreTools: 'Explore Our Advanced AI Video Tools',
        join: 'Join 10+ million users and create and inspire inspiration with 微鲤AI',
        startNow: 'Start Now',
    },
    fr: {
        title1: "Rencontrez notre IA générative d'images vers vidéo, tout-en-un",
        desc1: "微鲤AI est une plateforme d'IA générative d'images vers vidéo parfaite, tout-en-un. Nous offrons l'accès à tous les modèles vidéo de pointe, tous en un seul endroit. Essayez-les sans effort et créez des visuels impressionnants sans changer de plateforme !",
        moreModels: 'Plus de Modèles',
        showLess: 'Afficher Moins',
        title2: "Utilisez notre générateur d'images vers vidéo 微鲤AI pour animer vos images",
        desc2: "Utilisez 微鲤AI pour transformer n'importe quelle image en une histoire vivante ! Utilisez notre générateur d'images vers vidéo 微鲤AI pour générer des vidéos créatives (avec audio) à partir de vos photos. Que vous souhaitiez générer des scènes réalistes ou des animations, nous pouvons les créer rapidement selon vos besoins.",
        prompt: 'Consigne',
        title3: "Utilisez le générateur d'images vers vidéo 微鲤AI, ouvrez des possibilités infinies",
        desc3: 'Découvrez des styles créatifs infinis—des paysages urbains cyberpunk éclairés au néon aux paysages naturels à couper le souffle. Utilisez notre IA de texte vers vidéo pour créer des vidéos immersives de qualité cinématographique qui correspondent à votre vision unique.',
        getStarted: "Découvrez notre IA d'images vers vidéo",
        title4: "IA puissante d'images vers vidéo, au service des créateurs et des entreprises",
        tab1: 'Marques et Entrepreneurs',
        intro1: 'Donnez vie à votre marque et créez des histoires de marque inoubliables',
        info1: "Attirez l'attention du public et renforcez la notoriété de la marque grâce à un contenu de marque narratif.",
        tab2: 'Marketers et Agences',
        intro2: "Réduisez les coûts de production vidéo d'au moins 60%",
        info2: 'Créez du contenu de marque sans payer de coûts de production élevés. Générez des effets visuels uniques et époustouflants à des coûts extrêmement bas pour présenter professionnellement vos produits/services.',
        tab3: 'Réalisateurs',
        intro3: 'Générez facilement des vidéos cinématographiques époustouflantes',
        info3: 'Transformez rapidement des concepts créatifs en vidéos de haute qualité sans processus de post-production complexes. Exploitez la technologie IA pour raccourcir considérablement les cycles de production et donner vie rapidement à vos idées créatives.',
        tab4: 'Influenceurs',
        intro4: 'Créez des vidéos courtes accrocheuses',
        info4: "Produisez rapidement du contenu de haute qualité pour maintenir l'activité du compte. Créez du contenu vidéo court de qualité professionnelle seul, sans équipement ou équipe professionnels, en stimulant l'engagement des fans.",
        how_to_use_title:
            "Comment utiliser le générateur d'images vers vidéo 微鲤AI",
        how_to_use_desc:
            "Notre générateur d'images vers vidéo est conçu pour être très simple. Créez des vidéos facilement en seulement trois étapes.",
        step1_title:
            'Téléchargez une image, entrez le contenu et configurez les options personnalisées.',
        step2_title: "Lancez notre générateur d'images vers vidéo.",
        step3_title: 'Visualisez et téléchargez la vidéo générée.',
        otherVideo:
            'Débloquez la pleine puissance des autres générateurs de vidéo IA',
        exploreTools: 'Explore nos outils vidéo IA avancés',
        join: `Rejoignez 10+ millions d'utilisateurs et créez et inspirez l'inspiration avec 微鲤AI`,
        startNow: 'Commencer maintenant',
    },
    es: {
        title1: 'Conoce nuestra IA generativa de imágenes a videos, todo en uno',
        desc1: '微鲤AI es una plataforma de IA generativa de imágenes a videos perfecta, todo en uno. Ofrecemos acceso a todos los modelos de video de vanguardia, todos en un solo lugar. Intégralos fácilmente y crea visuales impresionantes sin cambiar de plataforma!',
        moreModels: 'Más Modelos',
        showLess: 'Mostrar Menos',
        title2: 'Utiliza nuestro generador de imágenes a videos 微鲤AI para animar tus imágenes',
        desc2: 'Utiliza 微鲤AI para convertir cualquier imagen en una historia viva! Utiliza nuestro generador de imágenes a videos 微鲤AI para generar videos creativos (con audio) desde tus fotos. Ya sea que quieras generar escenas realistas o animaciones, podemos crearlas rápidamente según tus necesidades.',
        prompt: 'Indicación',
        title3: 'Utiliza el generador de imágenes a video 微鲤AI, abre posibilidades infinitas',
        desc3: 'Experimenta estilos creativos infinitos: desde paisajes urbanos cyberpunk iluminados con neón hasta paisajes naturales impresionantes. Utiliza nuestra IA de texto a video para crear videos inmersivos de calidad cinematográfica que se alineen con tu visión única.',
        getStarted: 'Experimenta nuestra IA de imágenes a video',
        title4: 'IA potente de imágenes a video, empoderando a creadores y empresas',
        tab1: 'Marcas y Emprendedores',
        intro1: 'Dale vida a tu marca y crea historias de marca inolvidables',
        info1: 'Atrae la atención de la audiencia y mejora el reconocimiento de marca a través de contenido de marca narrativo.',
        tab2: 'Marketers y Agencias',
        intro2: 'Reduce los costos de producción de video en al menos 60%',
        info2: 'Crea contenido de marca sin pagar altos costos de producción. Genera efectos visuales únicos e impresionantes a costos extremadamente bajos para mostrar profesionalmente tus productos/servicios.',
        tab3: 'Cineastas',
        intro3: 'Genera fácilmente videos cinematográficos impresionantes',
        info3: 'Transforma rápidamente conceptos creativos en videos de alta calidad sin procesos complejos de postproducción. Aprovecha la tecnología IA para acortar significativamente los ciclos de producción y dar vida rápidamente a tus ideas creativas.',
        tab4: 'Influencers',
        intro4: 'Crea videos cortos llamativos',
        info4: 'Produce rápidamente contenido de alta calidad para mantener la actividad de la cuenta. Crea contenido de video corto de calidad profesional solo, sin equipos o equipos profesionales, aumentando el engagement de los seguidores.',
        how_to_use_title: 'Cómo usar el generador de imágenes a video 微鲤AI',
        how_to_use_desc:
            'Nuestro generador de imágenes a video está diseñado para ser muy simple. Crea videos fácilmente en solo tres pasos.',
        step1_title:
            'Sube una imagen, ingresa contenido y configura opciones personalizadas.',
        step2_title: 'Inicia nuestro generador de imágenes a video.',
        step3_title: 'Visualiza y descarga el video generado.',
        otherVideo:
            'Desbloquea el potencial completo de otros generadores de video IA',
        exploreTools: 'Explora nuestras herramientas de video IA avanzadas',
        join: 'Únete a más de 10 millones de usuarios y crea y inspira inspiración con 微鲤AI',
        startNow: 'Comenzar ahora',
    },
    ko: {
        title1: '우리의 이미지에서 비디오로의 AI 생성기, 모두를 한 곳에',
        desc1: 'WeryAI는 이미지에서 비디오로의 AI 생성기의 완벽한 플랫폼입니다. 우리는 모든 산업을 선도하는 비디오 모델에 대한 접근을 제공하며, 모두를 한 곳에 모읍니다. 그들을 쉽게 통합하고 다양한 플랫폼을 전환하지 않고도 놀라운 시각 효과를 만들 수 있습니다!',
        moreModels: '더 많은 모델',
        showLess: '접기',
        title2: '우리의 微鲤AI 이미지에서 비디오로의 AI 생성기를 사용하여 이미지를 애니메이션화하세요',
        desc2: 'WeryAI를 사용하여 모든 이미지를 생동감 있는 이야기로 변환하세요! 微鲤AI 이미지에서 비디오로의 AI 생성기를 사용하여 업로드한 사진에서 창의적인 비디오(오디오 포함)를 생성하세요. 실제 장면이나 애니메이션을 생성하려면 우리가 빠르게 만들 수 있습니다.',
        prompt: '프롬프트',
        title3: '微鲤AI 이미지에서 비디오로의 생성기를 사용하여 무한한 가능성을 시작하세요',
        desc3: '무한한 창의적 스타일을 경험하세요—네온으로 밝혀진 사이버펑크 도시 풍경부터 숨막히는 자연 풍경까지. 우리의 텍스트에서 비디오로의 AI를 사용하여 고유한 비전에 맞는 영화급 몰입형 비디오를 제작할 수 있습니다.',
        getStarted: '우리의 이미지에서 비디오로의 AI를 경험하세요',
        title4: '강력한 이미지에서 비디오로의 AI, 크리에이터와 기업을 지원합니다',
        tab1: '브랜드 및 기업가',
        intro1: '브랜드에 생명을 불어넣고 잊을 수 없는 브랜드 스토리를 만드세요',
        info1: '스토리텔링 브랜드 콘텐츠를 통해 관객의 관심을 끌고 브랜드 인지도를 높이세요.',
        tab2: '마케터 및 대행사',
        intro2: '비디오 제작 비용을 최소 60% 절감',
        info2: '높은 제작 비용을 지불하지 않고도 브랜드 콘텐츠를 제작하세요. 극히 낮은 비용으로 독특하고 놀라운 시각 효과를 생성하여 제품/서비스를 전문적으로 선보이세요.',
        tab3: '영화 제작자',
        intro3: '쉽게 놀라운 영화급 비디오를 생성하세요',
        info3: '복잡한 후반 작업 프로세스 없이 창의적인 개념을 고품질 비디오로 빠르게 변환하세요. AI 기술을 활용하여 제작 주기를 크게 단축하고 창의적인 아이디어를 빠르게 실현하세요.',
        tab4: '인플루언서',
        intro4: '눈에 띄는 짧은 비디오를 제작하세요',
        info4: '계정 활동을 유지하기 위해 고품질 콘텐츠를 빠르게 제작하세요. 전문 장비나 팀 없이 혼자서도 전문가급 짧은 비디오 콘텐츠를 제작하여 팬 참여도를 높이세요.',
        how_to_use_title: '微鲤AI 이미지에서 비디오로의 생성기 사용 방법',
        how_to_use_desc:
            '우리의 이미지에서 비디오로의 생성기는 매우 간단하게 설계되었습니다. 세 단계만으로 쉽게 비디오를 만들 수 있습니다.',
        step1_title:
            '이미지를 업로드하고, 내용을 입력하고, 사용자 정의 옵션을 구성하세요.',
        step2_title: '우리의 이미지에서 비디오로의 생성기를 시작하세요.',
        step3_title: '생성된 비디오를 확인하고 다운로드하세요.',
        otherVideo: '다른 AI 비디오 생성기의 전체 잠재력 해제',
        exploreTools: '고급 AI 비디오 도구 탐구',
        join: '1000만 명 이상의 사용자와 함께 WeryAI를 사용하여 창의적인 아이디어를 만들고 영감을 불러일으키세요',
        startNow: '지금 시작하세요',
    },
    tw: {

        title1: '让图片动起来，让创意无限可能',
        desc1: '微鲤AI 是一个完美的，一站式图片转视频 AI 平台。我们提供对所有行业领先视频模型的访问，所有这些都集中在WeryAI。无需在多个平台之间切换轻松尝试并创建令人惊叹的视觉效果，一切尽在WeryAI！',
        moreModels: '更多模型',
        showLess: '收起',
        title2: '使用WeryAI图生视频生成器为您的图像制作动画',
        desc2: '使用WeryAI将任何图像变成生动的故事！使用我们的 AI 图生视频生成器，将您上传的照片生成创意视频（带音频）。无论您想要生成逼真的场景还是动画，我们都能快速按照您的需求制作。',
        prompt: '提示词',
        title3: '使用WeryAI图生视频生成器，开启无限可能',
        desc3: '体验无限创意风格——从霓虹灯照亮的赛博朋克都市景观到令人叹为观止的自然风光等。使用我们的文生视频AI，您可以创作符合独特愿景的电影级沉浸视频。',
        getStarted: '体验我们的图生视频AI',
        title4: '强大的图生视频AI，助力创作者与企业',
        tab1: '品牌与企业家',
        intro1: '为您的品牌注入生命力，打造令人难忘的品牌故事',
        info1: '通过故事化的品牌内容，吸引受众关注并提升品牌知名度。',
        tab2: '营销人员和代理商',
        intro2: '视频制作成本降低至少60%',
        info2: '无需支付高昂的制作成本即可打造品牌内容。只需花费极低的成本，即可生成独特、惊艳的视觉效果，专业地展示您的产品/服务。',
        tab3: '电影制作人',
        intro3: '轻松生成震撼人心的电影级视频',
        info3: '无需复杂的后期制作流程，快速将创意概念转化为高质量视频。利用AI技术，大幅缩短制作周期，让您的创意想法快速落地。',
        tab4: '网红',
        intro4: '创作吸引眼球的短视频',
        info4: '快速产出高质量内容，保持账号活跃度。无需专业设备或团队，一个人即可创作出专业级的短视频内容，提升粉丝互动。',
        how_to_use_title: '如何使用WeryAI图生视频生成器',
        how_to_use_desc:
            '我们的图生视频生成器设计非常简单。只需三步即可轻松制作视频。',
        step1_title: '上传图片，输入内容并配置自定义选项。',
        step2_title: '启动我们的图生视频生成器。',
        step3_title: '查看并下载生成的视频。',
        otherVideo: '释放其他AI视频生成器的全部潜力',
        exploreTools: '探索我们先进的AI视频工具',
        join: '加入 1000 多万用户，使用WeryAI创造和启发灵感',
        startNow: '立即开始体验',
    },
    pl: {

        title1: 'Meet Our All-in-One Image to Video AI',
        desc1: '微鲤AI is a perfect, all-in-one image to video AI platform. We provide access to all the industry-leading video models, all in one single place. Try them seamlessly and create stunning visuals without juggling multiple platforms!',
        moreModels: 'More Models',
        showLess: 'Show Less',
        title2: 'Use 微鲤AI Image to Video Generator to animate your images',
        desc2: 'Use 微鲤AI to turn any image into a lively story! Use our AI image to video generator to generate creative videos (with audio) from your uploaded photos. Whether you want to generate realistic scenes or animations, we can quickly create them according to your needs.',
        prompt: 'Prompt',
        title3: 'Use 微鲤AI Image to Video Generator, start your infinite possibilities',
        desc3: 'Experience infinite creative styles—from neon-lit cyberpunk cityscapes to breathtaking natural landscapes. Use our text to video AI to create cinematic immersive videos that align with your unique vision.',
        getStarted: 'Experience our Image to Video AI',
        title4: 'Powerful Image to Video AI, Empowering Creators and Businesses',
        tab1: 'Brands & Entrepreneurs',
        intro1: 'Bring your brand to life and create unforgettable brand stories',
        info1: 'Attract audience attention and enhance brand awareness through storytelling brand content.',
        tab2: 'Marketers & Agencies',
        intro2: 'Reduce video production costs by at least 60%',
        info2: 'Create brand content without paying high production costs. Generate unique and stunning visual effects at extremely low costs to professionally showcase your products/services.',
        tab3: 'Filmmakers',
        intro3: 'Easily generate stunning cinematic videos',
        info3: 'Quickly transform creative concepts into high-quality videos without complex post-production processes. Leverage AI technology to significantly shorten production cycles and bring your creative ideas to life quickly.',
        tab4: 'Influencers',
        intro4: 'Create eye-catching short videos',
        info4: 'Quickly produce high-quality content to maintain account activity. Create professional-grade short video content alone without professional equipment or teams, boosting fan engagement.',
        how_to_use_title: 'How to Use 微鲤AI Image to Video Generator',
        how_to_use_desc:
            'Our image to video generator is designed to be very simple. Create videos easily in just three steps.',
        step1_title:
            'Upload an image, enter content and configure custom options.',
        step2_title: 'Launch our image to video generator.',
        step3_title: 'View and download the generated video.',
        otherVideo: 'Unlock the full potential of other AI video generators',
        exploreTools: 'Explore Our Advanced AI Video Tools',
        join: 'Join 10+ million users and create and inspire inspiration with 微鲤AI',
        startNow: 'Start Now',
    },
    ja: {
        title1: '私たちの画像からビデオへのAIジェネレーター、すべてを一つに',
        desc1: 'WeryAIは、画像からビデオへのAIジェネレーターの完璧なプラットフォームです。私たちは、すべての業界をリードするビデオモデルへのアクセスを提供し、すべてを一つの場所に集約しています。それらを簡単に統合し、複数のプラットフォームを切り替えることなく、驚くべき視覚効果を作成できます！',
        moreModels: 'もっとモデル',
        showLess: '折りたたむ',
        title2: 'WeryAIの画像からビデオへのAIジェネレーターを使用して画像をアニメーション化します',
        desc2: 'WeryAIを使用して、任意の画像を生き生きとした物語に変えましょう！ WeryAIの画像からビデオへのAIジェネレーターを使用して、アップロードした写真から創造的なビデオ（オーディオ付き）を生成します。 実際のシーンやアニメーションを生成する場合は、迅速に作成できます。',
        prompt: 'プロンプト',
        title3: 'WeryAI画像からビデオへのジェネレーターを使用して、無限の可能性を始めましょう',
        desc3: '無限の創造的なスタイルを体験してください—ネオンで照らされたサイバーパンクの都市景観から息を呑むような自然の風景まで。私たちのテキストからビデオへのAIを使用して、あなたの独自のビジョンに合わせた映画品質の没入型ビデオを作成できます。',
        getStarted: '私たちの画像からビデオへのAIを体験してください',
        title4: '強力な画像からビデオへのAI、クリエイターと企業を支援',
        tab1: 'ブランドと起業家',
        intro1: 'ブランドに命を吹き込み、忘れられないブランドストーリーを作成',
        info1: 'ストーリーテリングブランドコンテンツを通じて、視聴者の注目を集め、ブランド認知度を向上させます。',
        tab2: 'マーケターと代理店',
        intro2: 'ビデオ制作コストを少なくとも60%削減',
        info2: '高額な制作コストを支払うことなくブランドコンテンツを作成。極めて低コストでユニークで驚くべき視覚効果を生成し、製品/サービスを専門的に紹介します。',
        tab3: '映画制作者',
        intro3: '簡単に驚くべき映画品質のビデオを生成',
        info3: '複雑なポストプロダクションプロセスなしで、創造的なコンセプトを高品質のビデオに迅速に変換。AI技術を活用して制作サイクルを大幅に短縮し、創造的なアイデアを迅速に実現します。',
        tab4: 'インフルエンサー',
        intro4: '目を引くショートビデオを作成',
        info4: 'アカウントの活動を維持するために高品質のコンテンツを迅速に制作。専門的な機器やチームなしで一人でプロフェッショナルグレードのショートビデオコンテンツを作成し、ファンのエンゲージメントを向上させます。',
        how_to_use_title: 'WeryAI画像からビデオへのジェネレーターの使用方法',
        how_to_use_desc:
            '私たちの画像からビデオへのジェネレーターは非常にシンプルに設計されています。わずか3ステップで簡単にビデオを作成できます。',
        step1_title:
            '画像をアップロードし、コンテンツを入力し、カスタムオプションを設定します。',
        step2_title: '私たちの画像からビデオへのジェネレーターを起動します。',
        step3_title: '生成されたビデオを表示してダウンロードします。',
        otherVideo: '他のAIビデオジェネレーターの完全な潜在能力を解放',
        exploreTools: '高度なAIビデオツールを探索',
        join: '1000万人以上のユーザーとともにWeryAIを使用して、創造的なアイデアを作成し、インスピレーションを呼び起こしましょう',
        startNow: '今すぐ始める',
    },
    pt: {
        title1: 'Conheça nosso gerador de IA de imagens para vídeos, tudo em um',
        desc1: '微鲤AI é uma plataforma de IA geradora de imagens para vídeos perfeita, tudo em um. Oferecemos acesso a todos os modelos de vídeo de ponta, todos em um único lugar. Integre-os facilmente e crie visuais impressionantes sem mudar de plataforma!',
        moreModels: 'Mais Modelos',
        showLess: 'Mostrar Menos',
        title2: 'Use nosso gerador de imagens para vídeos 微鲤AI para animar suas imagens',
        desc2: 'Use 微鲤AI para transformar qualquer imagem em uma história viva! Use nosso gerador de imagens para vídeos 微鲤AI para gerar vídeos criativos (com áudio) a partir de suas fotos. Quer gerar cenários realistas ou animações, podemos criar rapidamente de acordo com suas necessidades.',
        prompt: 'Instrução',
        title3: 'Use o gerador de imagens para vídeo 微鲤AI, abra possibilidades infinitas',
        desc3: 'Experimente estilos criativos infinitos—de paisagens urbanas cyberpunk iluminadas por néon a paisagens naturais de tirar o fôlego. Use nossa IA de texto para vídeo para criar vídeos imersivos de qualidade cinematográfica que se alinhem com sua visão única.',
        getStarted: 'Experimente nossa IA de imagens para vídeo',
        title4: 'IA poderosa de imagens para vídeo, capacitando criadores e empresas',
        tab1: 'Marcas e Empreendedores',
        intro1: 'Dê vida à sua marca e crie histórias de marca inesquecíveis',
        info1: 'Atraia a atenção do público e aumente o reconhecimento da marca através de conteúdo de marca narrativo.',
        tab2: 'Marketers e Agências',
        intro2: 'Reduza os custos de produção de vídeo em pelo menos 60%',
        info2: 'Crie conteúdo de marca sem pagar altos custos de produção. Gere efeitos visuais únicos e impressionantes a custos extremamente baixos para mostrar profissionalmente seus produtos/serviços.',
        tab3: 'Cineastas',
        intro3: 'Gere facilmente vídeos cinematográficos impressionantes',
        info3: 'Transforme rapidamente conceitos criativos em vídeos de alta qualidade sem processos complexos de pós-produção. Aproveite a tecnologia IA para encurtar significativamente os ciclos de produção e dar vida rapidamente às suas ideias criativas.',
        tab4: 'Influenciadores',
        intro4: 'Crie vídeos curtos chamativos',
        info4: 'Produza rapidamente conteúdo de alta qualidade para manter a atividade da conta. Crie conteúdo de vídeo curto de qualidade profissional sozinho, sem equipamentos ou equipes profissionais, aumentando o engajamento dos fãs.',
        how_to_use_title: 'Como usar o gerador de imagens para vídeo 微鲤AI',
        how_to_use_desc:
            'Nosso gerador de imagens para vídeo foi projetado para ser muito simples. Crie vídeos facilmente em apenas três passos.',
        step1_title:
            'Faça upload de uma imagem, insira conteúdo e configure opções personalizadas.',
        step2_title: 'Inicie nosso gerador de imagens para vídeo.',
        step3_title: 'Visualize e baixe o vídeo gerado.',
        otherVideo:
            'Desbloqueie o potencial completo de outros geradores de vídeo IA',
        exploreTools: 'Explore nossas ferramentas de vídeo IA avançadas',
        join: 'Junte-se a mais de 10 milhões de usuários e crie e inspire inspiração com 微鲤AI',
        startNow: 'Comece agora',
    },
    de: {
        title1: 'Unsere AI-Generierung von Bildern zu Videos, alles in einem',
        desc1: '微鲤AI ist eine perfekte, all-in-one-Plattform für die AI-Generierung von Bildern zu Videos. Wir bieten Zugriff auf alle führenden Videomodelle, alle an einem einzigen Ort. Probieren Sie sie einfach aus und erstellen Sie beeindruckende visuelle Effekte ohne den Wechsel zwischen verschiedenen Plattformen!',
        moreModels: 'Mehr Modelle',
        showLess: 'Weniger Anzeigen',
        title2: 'Unsere 微鲤AI AI-Generierung von Bildern zu Videos, um Bilder zu animieren',
        desc2: '微鲤AI ist eine perfekte, all-in-one-Plattform für die AI-Generierung von Bildern zu Videos. Wir bieten Zugriff auf alle führenden Videomodelle, alle an einem einzigen Ort. Probieren Sie sie einfach aus und erstellen Sie beeindruckende visuelle Effekte ohne den Wechsel zwischen verschiedenen Plattformen!',
        prompt: 'Anweisung',
        title3: 'Verwenden Sie den 微鲤AI Bild-zu-Video-Generator, eröffnen Sie unendliche Möglichkeiten',
        desc3: 'Erleben Sie unendliche kreative Stile—von neonbeleuchteten Cyberpunk-Stadtlandschaften bis hin zu atemberaubenden Naturlandschaften. Verwenden Sie unsere Text-zu-Video-KI, um filmreife, immersive Videos zu erstellen, die Ihrer einzigartigen Vision entsprechen.',
        getStarted: 'Erleben Sie unsere Bild-zu-Video-KI',
        title4: 'Leistungsstarke Bild-zu-Video-KI, die Kreative und Unternehmen stärkt',
        tab1: 'Marken & Unternehmer',
        intro1: 'Erwecken Sie Ihre Marke zum Leben und schaffen Sie unvergessliche Markengeschichten',
        info1: 'Ziehen Sie die Aufmerksamkeit des Publikums auf sich und steigern Sie die Markenbekanntheit durch erzählerische Markeninhalte.',
        tab2: 'Marketer & Agenturen',
        intro2: 'Reduzieren Sie die Videoproduktionskosten um mindestens 60%',
        info2: 'Erstellen Sie Markeninhalte ohne hohe Produktionskosten zu zahlen. Generieren Sie einzigartige und atemberaubende visuelle Effekte zu extrem niedrigen Kosten, um Ihre Produkte/Dienstleistungen professionell zu präsentieren.',
        tab3: 'Filmemacher',
        intro3: 'Erstellen Sie mühelos atemberaubende filmische Videos',
        info3: 'Verwandeln Sie kreative Konzepte schnell in hochwertige Videos ohne komplexe Postproduktionsprozesse. Nutzen Sie KI-Technologie, um Produktionszyklen erheblich zu verkürzen und Ihre kreativen Ideen schnell zum Leben zu erwecken.',
        tab4: 'Influencer',
        intro4: 'Erstellen Sie auffällige Kurzvideos',
        info4: 'Produzieren Sie schnell hochwertige Inhalte, um die Kontenaktivität aufrechtzuerhalten. Erstellen Sie allein professionelle Kurzvideoinhalte ohne professionelle Ausrüstung oder Teams und steigern Sie das Fan-Engagement.',
        how_to_use_title:
            'Wie man den 微鲤AI Bild-zu-Video-Generator verwendet',
        how_to_use_desc:
            'Unser Bild-zu-Video-Generator ist sehr einfach gestaltet. Erstellen Sie Videos ganz einfach in nur drei Schritten.',
        step1_title:
            'Laden Sie ein Bild hoch, geben Sie Inhalte ein und konfigurieren Sie benutzerdefinierte Optionen.',
        step2_title: 'Starten Sie unseren Bild-zu-Video-Generator.',
        step3_title:
            'Sehen Sie sich das generierte Video an und laden Sie es herunter.',
        otherVideo:
            'Entsperren Sie die volle Potenzialität anderer AI-Video-Generatoren',
        exploreTools: 'Entdecken Sie unsere fortschrittlichen AI-Video-Tools',
        join: '10+ Millionen Nutzer und erstellen Sie und inspirieren Sie Inspiration mit 微鲤AI',
        startNow: 'Jetzt starten',
    },
    it: {
        title1: "Il nostro generatore di IA di immagini a video, tutto in un'unica piattaforma",
        desc1: "微鲤AI è una piattaforma di IA generativa di immagini a video perfetta, tutto in un'unica piattaforma. Offriamo accesso a tutti i modelli video di punta, tutti in un solo posto. Integrali facilmente e crea visuali impressionanti senza cambiare piattaforma!",
        moreModels: 'Più Modelli',
        showLess: 'Mostra Meno',
        title2: 'Utilizza il nostro generatore di immagini a video 微鲤AI per animare le tue immagini',
        desc2: 'Utilizza 微鲤AI per trasformare qualsiasi immagine in una storia viva! Utilizza il nostro generatore di immagini a video 微鲤AI per generare video creativi (con audio) dalle tue foto. Vuoi generare scene realistiche o animazioni, possiamo crearle rapidamente secondo le tue necessità.',
        prompt: 'Istruzione',
        title3: 'Usa il generatore di immagini a video 微鲤AI, apri possibilità infinite',
        desc3: 'Sperimenta stili creativi infiniti—dai paesaggi urbani cyberpunk illuminati al neon ai paesaggi naturali mozzafiato. Usa la nostra IA di testo a video per creare video immersivi di qualità cinematografica che si allineano con la tua visione unica.',
        getStarted: 'Sperimenta la nostra IA di immagini a video',
        title4: 'IA potente da immagini a video, che potenzia creatori e aziende',
        tab1: 'Marchi e Imprenditori',
        intro1: 'Dai vita al tuo brand e crea storie di marca indimenticabili',
        info1: "Attira l'attenzione del pubblico e aumenta la notorietà del brand attraverso contenuti di marca narrativi.",
        tab2: 'Marketer e Agenzie',
        intro2: 'Riduci i costi di produzione video di almeno il 60%',
        info2: 'Crea contenuti di marca senza pagare costi di produzione elevati. Genera effetti visivi unici e sorprendenti a costi estremamente bassi per mostrare professionalmente i tuoi prodotti/servizi.',
        tab3: 'Registi',
        intro3: 'Genera facilmente video cinematografici mozzafiato',
        info3: 'Trasforma rapidamente concetti creativi in video di alta qualità senza processi complessi di post-produzione. Sfrutta la tecnologia IA per ridurre significativamente i cicli di produzione e dare vita rapidamente alle tue idee creative.',
        tab4: 'Influencer',
        intro4: 'Crea video brevi accattivanti',
        info4: "Produca rapidamente contenuti di alta qualità per mantenere l'attività dell'account. Crea contenuti video brevi di qualità professionale da solo, senza attrezzature o team professionali, aumentando l'engagement dei fan.",
        how_to_use_title: 'Come usare il generatore di immagini a video 微鲤AI',
        how_to_use_desc:
            'Il nostro generatore di immagini a video è progettato per essere molto semplice. Crea video facilmente in soli tre passaggi.',
        step1_title:
            "Carica un'immagine, inserisci contenuti e configura opzioni personalizzate.",
        step2_title: 'Avvia il nostro generatore di immagini a video.',
        step3_title: 'Visualizza e scarica il video generato.',
        otherVideo:
            'Sblocca il potenziale completo di altri generatori di video IA',
        exploreTools: 'Esplora le nostre potenti AI video tools',
        join: `Unisciti a più di 10 milioni di utenti e crea e ispira l'ispirazione con 微鲤AI`,
        startNow: 'Inizia ora',
    },
    ru: {
        title1: 'Наш генератор AI из изображений в видео, все в одном',
        desc1: '微鲤AI — это идеальная, все-в-одном платформа для генерации видео из изображений. Мы предоставляем доступ ко всем ведущим моделям видео, все в одном месте. Легко интегрируйте и создавайте впечатляющие визуальные эффекты без переключения между различными платформами!',
        moreModels: 'Больше Моделей',
        showLess: 'Скрыть',
        title2: 'Используйте наш генератор AI из изображений в видео 微鲤AI для анимации ваших изображений',
        desc2: 'Используйте 微鲤AI для превращения любого изображения в живое повествование! Используйте наш генератор AI из изображений в видео 微鲤AI для генерации творческих видео (с аудио) из ваших фотографий. Хотите генерировать реалистичные сцены или анимации, мы можем быстро создать их в соответствии с вашими потребностями.',
        prompt: 'Запрос',
        title3: 'Используйте генератор изображений в видео 微鲤AI, откройте бесконечные возможности',
        desc3: 'Испытайте бесконечные творческие стили—от неоновых киберпанк-городских пейзажей до захватывающих дух природных ландшафтов. Используйте наш AI для преобразования текста в видео, чтобы создавать кинематографические иммерсивные видео, соответствующие вашему уникальному видению.',
        getStarted: 'Испытайте наш AI для преобразования изображений в видео',
        title4: 'Мощный AI для преобразования изображений в видео, расширяющий возможности создателей и бизнеса',
        tab1: 'Бренды и Предприниматели',
        intro1: 'Вдохните жизнь в свой бренд и создайте незабываемые истории бренда',
        info1: 'Привлекайте внимание аудитории и повышайте узнаваемость бренда через повествовательный контент бренда.',
        tab2: 'Маркетологи и Агентства',
        intro2: 'Снизьте затраты на производство видео как минимум на 60%',
        info2: 'Создавайте контент бренда без оплаты высоких затрат на производство. Генерируйте уникальные и потрясающие визуальные эффекты по крайне низкой стоимости, чтобы профессионально продемонстрировать ваши продукты/услуги.',
        tab3: 'Кинорежиссеры',
        intro3: 'Легко создавайте потрясающие кинематографические видео',
        info3: 'Быстро преобразуйте творческие концепции в высококачественные видео без сложных процессов постпродакшна. Используйте технологии AI, чтобы значительно сократить производственные циклы и быстро воплотить ваши творческие идеи в жизнь.',
        tab4: 'Инфлюенсеры',
        intro4: 'Создавайте привлекающие внимание короткие видео',
        info4: 'Быстро создавайте высококачественный контент для поддержания активности аккаунта. Создавайте профессиональные короткие видеоролики в одиночку, без профессионального оборудования или команд, повышая вовлеченность поклонников.',
        how_to_use_title:
            'Как использовать генератор изображений в видео 微鲤AI',
        how_to_use_desc:
            'Наш генератор изображений в видео разработан очень просто. Создавайте видео легко всего за три шага.',
        step1_title:
            'Загрузите изображение, введите содержимое и настройте пользовательские параметры.',
        step2_title: 'Запустите наш генератор изображений в видео.',
        step3_title: 'Просмотрите и загрузите сгенерированное видео.',
        otherVideo: 'Освободите полный потенциал других генераторов видео AI',
        exploreTools: 'Исследуйте наши мощные инструменты AI видео',
        join: 'Присоединяйтесь к более чем 10 миллионам пользователей и создавайте и вдохновляйте вдохновение с 微鲤AI',
        startNow: 'Начать сейчас',
    },
    ar: {
        title1: 'مولد الفيديو من الصور، كل شيء في مكان واحد',
        desc1: '微鲤AI هي منصة جميع-في-واحد لتحويل الصور إلى فيديو باستخدام الذكاء الاصطناعي. نقدم الوصول إلى جميع النماذج الرائدة في الصناعة، كلها في مكان واحد. جربها بسهولة وأنشئ تأثيرات تصويرية مذهلة دون التبديل بين المنصات!',
        moreModels: 'المزيد من النماذج',
        showLess: 'إظهار أقل',
        title2: 'استخدم مولد الفيديو من الصور، 微鲤AI لتحويل الصور إلى فيديو باستخدام الذكاء الاصطناعي لتحريك الصور',
        desc2: 'استخدم 微鲤AI لتحويل أي صورة إلى قصة حية! استخدم مولد الفيديو من الصور، 微鲤AI لتحويل الصور إلى فيديو باستخدام الذكاء الاصطناعي لتحريك الصور. ستقوم بتحريك الصور إلى فيديو باستخدام الذكاء الاصطناعي لتحريك الصور',
        prompt: 'توجيه',
        title3: 'استخدم مولد الصور إلى الفيديو 微鲤AI، ابدأ إمكانياتك اللامتناهية',
        desc3: 'اختبر أنماطًا إبداعية لا نهائية—من مشاهد المدن السيبرية المضاءة بالنيون إلى المناظر الطبيعية الخلابة. استخدم ذكاءنا الاصطناعي للنص إلى الفيديو لإنشاء مقاطع فيديو سينمائية غامرة تتماشى مع رؤيتك الفريدة.',
        getStarted: 'اختبر ذكاءنا الاصطناعي للصور إلى الفيديو',
        title4: 'ذكاء اصطناعي قوي للصور إلى الفيديو، يدعم المبدعين والشركات',
        tab1: 'العلامات التجارية ورجال الأعمال',
        intro1: 'أضف الحياة إلى علامتك التجارية وأنشئ قصص علامة تجارية لا تُنسى',
        info1: 'اجذب انتباه الجمهور وزد من شهرة العلامة التجارية من خلال محتوى العلامة التجارية السردي.',
        tab2: 'المسوقون والوكالات',
        intro2: 'قلل تكاليف إنتاج الفيديو بنسبة 60% على الأقل',
        info2: 'أنشئ محتوى علامة تجارية دون دفع تكاليف إنتاج باهظة. أنشئ تأثيرات بصرية فريدة ومذهلة بتكلفة منخفضة للغاية لعرض منتجاتك/خدماتك بشكل احترافي.',
        tab3: 'صانعو الأفلام',
        intro3: 'أنشئ بسهولة مقاطع فيديو سينمائية مذهلة',
        info3: 'حول المفاهيم الإبداعية بسرعة إلى مقاطع فيديو عالية الجودة دون عمليات ما بعد الإنتاج المعقدة. استفد من تقنية الذكاء الاصطناعي لتقليل دورات الإنتاج بشكل كبير وإحياء أفكارك الإبداعية بسرعة.',
        tab4: 'المؤثرون',
        intro4: 'أنشئ مقاطع فيديو قصيرة جذابة',
        info4: 'أنتج محتوى عالي الجودة بسرعة للحفاظ على نشاط الحساب. أنشئ محتوى فيديو قصير احترافي بمفردك، دون معدات أو فرق احترافية، مما يعزز تفاعل المعجبين.',
        how_to_use_title: 'كيفية استخدام مولد الصور إلى الفيديو 微鲤AI',
        how_to_use_desc:
            'تم تصميم مولد الصور إلى الفيديو الخاص بنا ليكون بسيطًا جدًا. أنشئ مقاطع فيديو بسهولة في ثلاث خطوات فقط.',
        step1_title:
            'قم بتحميل صورة، وأدخل المحتوى وقم بتكوين الخيارات المخصصة.',
        step2_title: 'قم بتشغيل مولد الصور إلى الفيديو الخاص بنا.',
        step3_title: 'عرض وتنزيل الفيديو المُنشأ.',
        otherVideo:
            'إفراغ إمكانات جميع أنظمة التحويل من الصور إلى الفيديو الآلي',
        exploreTools: 'استكشف أدواتنا الذكاء الاصطناعي القوية للفيديو',
        join: 'انضم إلى أكثر من 10 ملايين مستخدم وأنشئ وألهم الإلهام باستخدام 微鲤AI',
        startNow: 'ابدأ الآن',
        },
    th: { // Thai (copied from English)
        title1: 'Meet Our All-in-One Image to Video AI',
        desc1: '微鲤AI is a perfect, all-in-one image to video AI platform. We provide access to all the industry-leading video models, all in one single place. Try them seamlessly and create stunning visuals without juggling multiple platforms!',
        moreModels: 'More Models',
        showLess: 'Show Less',
        title2: 'Use 微鲤AI Image to Video Generator to animate your images',
        desc2: 'Use 微鲤AI to turn any image into a lively story! Use our AI image to video generator to generate creative videos (with audio) from your uploaded photos. Whether you want to generate realistic scenes or animations, we can quickly create them according to your needs.',
        prompt: 'Prompt',
        title3: 'Use 微鲤AI Image to Video Generator, start your infinite possibilities',
        desc3: 'Experience infinite creative styles—from neon-lit cyberpunk cityscapes to breathtaking natural landscapes. Use our text to video AI to create cinematic immersive videos that align with your unique vision.',
        getStarted: 'Experience our Image to Video AI',
        title4: 'Powerful Image to Video AI, Empowering Creators and Businesses',
        tab1: 'Brands & Entrepreneurs',
        intro1: 'Bring your brand to life and create unforgettable brand stories',
        info1: 'Attract audience attention and enhance brand awareness through storytelling brand content.',
        tab2: 'Marketers & Agencies',
        intro2: 'Reduce video production costs by at least 60%',
        info2: 'Create brand content without paying high production costs. Generate unique and stunning visual effects at extremely low costs to professionally showcase your products/services.',
        tab3: 'Filmmakers',
        intro3: 'Easily generate stunning cinematic videos',
        info3: 'Quickly transform creative concepts into high-quality videos without complex post-production processes. Leverage AI technology to significantly shorten production cycles and bring your creative ideas to life quickly.',
        tab4: 'Influencers',
        intro4: 'Create eye-catching short videos',
        info4: 'Quickly produce high-quality content to maintain account activity. Create professional-grade short video content alone without professional equipment or teams, boosting fan engagement.',
        how_to_use_title: 'How to Use 微鲤AI Image to Video Generator',
        how_to_use_desc:
            'Our image to video generator is designed to be very simple. Create videos easily in just three steps.',
        step1_title:
            'Upload an image, enter content and configure custom options.',
        step2_title: 'Launch our image to video generator.',
        step3_title: 'View and download the generated video.',
        otherVideo: 'Unlock the full potential of other AI video generators',
        exploreTools: 'Explore Our Advanced AI Video Tools',
        join: 'Join 10+ million users and create and inspire inspiration with 微鲤AI',
        startNow: 'Start Now',
        },
    da: { // Danish (copied from English)
        title1: 'Meet Our All-in-One Image to Video AI',
        desc1: '微鲤AI is a perfect, all-in-one image to video AI platform. We provide access to all the industry-leading video models, all in one single place. Try them seamlessly and create stunning visuals without juggling multiple platforms!',
        moreModels: 'More Models',
        showLess: 'Show Less',
        title2: 'Use 微鲤AI Image to Video Generator to animate your images',
        desc2: 'Use 微鲤AI to turn any image into a lively story! Use our AI image to video generator to generate creative videos (with audio) from your uploaded photos. Whether you want to generate realistic scenes or animations, we can quickly create them according to your needs.',
        prompt: 'Prompt',
        title3: 'Use 微鲤AI Image to Video Generator, start your infinite possibilities',
        desc3: 'Experience infinite creative styles—from neon-lit cyberpunk cityscapes to breathtaking natural landscapes. Use our text to video AI to create cinematic immersive videos that align with your unique vision.',
        getStarted: 'Experience our Image to Video AI',
        title4: 'Powerful Image to Video AI, Empowering Creators and Businesses',
        tab1: 'Brands & Entrepreneurs',
        intro1: 'Bring your brand to life and create unforgettable brand stories',
        info1: 'Attract audience attention and enhance brand awareness through storytelling brand content.',
        tab2: 'Marketers & Agencies',
        intro2: 'Reduce video production costs by at least 60%',
        info2: 'Create brand content without paying high production costs. Generate unique and stunning visual effects at extremely low costs to professionally showcase your products/services.',
        tab3: 'Filmmakers',
        intro3: 'Easily generate stunning cinematic videos',
        info3: 'Quickly transform creative concepts into high-quality videos without complex post-production processes. Leverage AI technology to significantly shorten production cycles and bring your creative ideas to life quickly.',
        tab4: 'Influencers',
        intro4: 'Create eye-catching short videos',
        info4: 'Quickly produce high-quality content to maintain account activity. Create professional-grade short video content alone without professional equipment or teams, boosting fan engagement.',
        how_to_use_title: 'How to Use 微鲤AI Image to Video Generator',
        how_to_use_desc:
            'Our image to video generator is designed to be very simple. Create videos easily in just three steps.',
        step1_title:
            'Upload an image, enter content and configure custom options.',
        step2_title: 'Launch our image to video generator.',
        step3_title: 'View and download the generated video.',
        otherVideo: 'Unlock the full potential of other AI video generators',
        exploreTools: 'Explore Our Advanced AI Video Tools',
        join: 'Join 10+ million users and create and inspire inspiration with 微鲤AI',
        startNow: 'Start Now',
        },
    no: { // Norwegian (copied from English)
        title1: 'Meet Our All-in-One Image to Video AI',
        desc1: '微鲤AI is a perfect, all-in-one image to video AI platform. We provide access to all the industry-leading video models, all in one single place. Try them seamlessly and create stunning visuals without juggling multiple platforms!',
        moreModels: 'More Models',
        showLess: 'Show Less',
        title2: 'Use 微鲤AI Image to Video Generator to animate your images',
        desc2: 'Use 微鲤AI to turn any image into a lively story! Use our AI image to video generator to generate creative videos (with audio) from your uploaded photos. Whether you want to generate realistic scenes or animations, we can quickly create them according to your needs.',
        prompt: 'Prompt',
        title3: 'Use 微鲤AI Image to Video Generator, start your infinite possibilities',
        desc3: 'Experience infinite creative styles—from neon-lit cyberpunk cityscapes to breathtaking natural landscapes. Use our text to video AI to create cinematic immersive videos that align with your unique vision.',
        getStarted: 'Experience our Image to Video AI',
        title4: 'Powerful Image to Video AI, Empowering Creators and Businesses',
        tab1: 'Brands & Entrepreneurs',
        intro1: 'Bring your brand to life and create unforgettable brand stories',
        info1: 'Attract audience attention and enhance brand awareness through storytelling brand content.',
        tab2: 'Marketers & Agencies',
        intro2: 'Reduce video production costs by at least 60%',
        info2: 'Create brand content without paying high production costs. Generate unique and stunning visual effects at extremely low costs to professionally showcase your products/services.',
        tab3: 'Filmmakers',
        intro3: 'Easily generate stunning cinematic videos',
        info3: 'Quickly transform creative concepts into high-quality videos without complex post-production processes. Leverage AI technology to significantly shorten production cycles and bring your creative ideas to life quickly.',
        tab4: 'Influencers',
        intro4: 'Create eye-catching short videos',
        info4: 'Quickly produce high-quality content to maintain account activity. Create professional-grade short video content alone without professional equipment or teams, boosting fan engagement.',
        how_to_use_title: 'How to Use 微鲤AI Image to Video Generator',
        how_to_use_desc:
            'Our image to video generator is designed to be very simple. Create videos easily in just three steps.',
        step1_title:
            'Upload an image, enter content and configure custom options.',
        step2_title: 'Launch our image to video generator.',
        step3_title: 'View and download the generated video.',
        otherVideo: 'Unlock the full potential of other AI video generators',
        exploreTools: 'Explore Our Advanced AI Video Tools',
        join: 'Join 10+ million users and create and inspire inspiration with 微鲤AI',
        startNow: 'Start Now',
        },
    nl: { // Dutch (copied from English)
        title1: 'Meet Our All-in-One Image to Video AI',
        desc1: '微鲤AI is a perfect, all-in-one image to video AI platform. We provide access to all the industry-leading video models, all in one single place. Try them seamlessly and create stunning visuals without juggling multiple platforms!',
        moreModels: 'More Models',
        showLess: 'Show Less',
        title2: 'Use 微鲤AI Image to Video Generator to animate your images',
        desc2: 'Use 微鲤AI to turn any image into a lively story! Use our AI image to video generator to generate creative videos (with audio) from your uploaded photos. Whether you want to generate realistic scenes or animations, we can quickly create them according to your needs.',
        prompt: 'Prompt',
        title3: 'Use 微鲤AI Image to Video Generator, start your infinite possibilities',
        desc3: 'Experience infinite creative styles—from neon-lit cyberpunk cityscapes to breathtaking natural landscapes. Use our text to video AI to create cinematic immersive videos that align with your unique vision.',
        getStarted: 'Experience our Image to Video AI',
        title4: 'Powerful Image to Video AI, Empowering Creators and Businesses',
        tab1: 'Brands & Entrepreneurs',
        intro1: 'Bring your brand to life and create unforgettable brand stories',
        info1: 'Attract audience attention and enhance brand awareness through storytelling brand content.',
        tab2: 'Marketers & Agencies',
        intro2: 'Reduce video production costs by at least 60%',
        info2: 'Create brand content without paying high production costs. Generate unique and stunning visual effects at extremely low costs to professionally showcase your products/services.',
        tab3: 'Filmmakers',
        intro3: 'Easily generate stunning cinematic videos',
        info3: 'Quickly transform creative concepts into high-quality videos without complex post-production processes. Leverage AI technology to significantly shorten production cycles and bring your creative ideas to life quickly.',
        tab4: 'Influencers',
        intro4: 'Create eye-catching short videos',
        info4: 'Quickly produce high-quality content to maintain account activity. Create professional-grade short video content alone without professional equipment or teams, boosting fan engagement.',
        how_to_use_title: 'How to Use 微鲤AI Image to Video Generator',
        how_to_use_desc:
            'Our image to video generator is designed to be very simple. Create videos easily in just three steps.',
        step1_title:
            'Upload an image, enter content and configure custom options.',
        step2_title: 'Launch our image to video generator.',
        step3_title: 'View and download the generated video.',
        otherVideo: 'Unlock the full potential of other AI video generators',
        exploreTools: 'Explore Our Advanced AI Video Tools',
        join: 'Join 10+ million users and create and inspire inspiration with 微鲤AI',
        startNow: 'Start Now',
        },
    id: { // Indonesian (copied from English)
        title1: 'Meet Our All-in-One Image to Video AI',
        desc1: '微鲤AI is a perfect, all-in-one image to video AI platform. We provide access to all the industry-leading video models, all in one single place. Try them seamlessly and create stunning visuals without juggling multiple platforms!',
        moreModels: 'More Models',
        showLess: 'Show Less',
        title2: 'Use 微鲤AI Image to Video Generator to animate your images',
        desc2: 'Use 微鲤AI to turn any image into a lively story! Use our AI image to video generator to generate creative videos (with audio) from your uploaded photos. Whether you want to generate realistic scenes or animations, we can quickly create them according to your needs.',
        prompt: 'Prompt',
        title3: 'Use 微鲤AI Image to Video Generator, start your infinite possibilities',
        desc3: 'Experience infinite creative styles—from neon-lit cyberpunk cityscapes to breathtaking natural landscapes. Use our text to video AI to create cinematic immersive videos that align with your unique vision.',
        getStarted: 'Experience our Image to Video AI',
        title4: 'Powerful Image to Video AI, Empowering Creators and Businesses',
        tab1: 'Brands & Entrepreneurs',
        intro1: 'Bring your brand to life and create unforgettable brand stories',
        info1: 'Attract audience attention and enhance brand awareness through storytelling brand content.',
        tab2: 'Marketers & Agencies',
        intro2: 'Reduce video production costs by at least 60%',
        info2: 'Create brand content without paying high production costs. Generate unique and stunning visual effects at extremely low costs to professionally showcase your products/services.',
        tab3: 'Filmmakers',
        intro3: 'Easily generate stunning cinematic videos',
        info3: 'Quickly transform creative concepts into high-quality videos without complex post-production processes. Leverage AI technology to significantly shorten production cycles and bring your creative ideas to life quickly.',
        tab4: 'Influencers',
        intro4: 'Create eye-catching short videos',
        info4: 'Quickly produce high-quality content to maintain account activity. Create professional-grade short video content alone without professional equipment or teams, boosting fan engagement.',
        how_to_use_title: 'How to Use 微鲤AI Image to Video Generator',
        how_to_use_desc:
            'Our image to video generator is designed to be very simple. Create videos easily in just three steps.',
        step1_title:
            'Upload an image, enter content and configure custom options.',
        step2_title: 'Launch our image to video generator.',
        step3_title: 'View and download the generated video.',
        otherVideo: 'Unlock the full potential of other AI video generators',
        exploreTools: 'Explore Our Advanced AI Video Tools',
        join: 'Join 10+ million users and create and inspire inspiration with 微鲤AI',
        startNow: 'Start Now',
        },
    tr: { // Turkish (copied from English)
        title1: 'Meet Our All-in-One Image to Video AI',
        desc1: '微鲤AI is a perfect, all-in-one image to video AI platform. We provide access to all the industry-leading video models, all in one single place. Try them seamlessly and create stunning visuals without juggling multiple platforms!',
        moreModels: 'More Models',
        showLess: 'Show Less',
        title2: 'Use 微鲤AI Image to Video Generator to animate your images',
        desc2: 'Use 微鲤AI to turn any image into a lively story! Use our AI image to video generator to generate creative videos (with audio) from your uploaded photos. Whether you want to generate realistic scenes or animations, we can quickly create them according to your needs.',
        prompt: 'Prompt',
        title3: 'Use 微鲤AI Image to Video Generator, start your infinite possibilities',
        desc3: 'Experience infinite creative styles—from neon-lit cyberpunk cityscapes to breathtaking natural landscapes. Use our text to video AI to create cinematic immersive videos that align with your unique vision.',
        getStarted: 'Experience our Image to Video AI',
        title4: 'Powerful Image to Video AI, Empowering Creators and Businesses',
        tab1: 'Brands & Entrepreneurs',
        intro1: 'Bring your brand to life and create unforgettable brand stories',
        info1: 'Attract audience attention and enhance brand awareness through storytelling brand content.',
        tab2: 'Marketers & Agencies',
        intro2: 'Reduce video production costs by at least 60%',
        info2: 'Create brand content without paying high production costs. Generate unique and stunning visual effects at extremely low costs to professionally showcase your products/services.',
        tab3: 'Filmmakers',
        intro3: 'Easily generate stunning cinematic videos',
        info3: 'Quickly transform creative concepts into high-quality videos without complex post-production processes. Leverage AI technology to significantly shorten production cycles and bring your creative ideas to life quickly.',
        tab4: 'Influencers',
        intro4: 'Create eye-catching short videos',
        info4: 'Quickly produce high-quality content to maintain account activity. Create professional-grade short video content alone without professional equipment or teams, boosting fan engagement.',
        how_to_use_title: 'How to Use 微鲤AI Image to Video Generator',
        how_to_use_desc:
            'Our image to video generator is designed to be very simple. Create videos easily in just three steps.',
        step1_title:
            'Upload an image, enter content and configure custom options.',
        step2_title: 'Launch our image to video generator.',
        step3_title: 'View and download the generated video.',
        otherVideo: 'Unlock the full potential of other AI video generators',
        exploreTools: 'Explore Our Advanced AI Video Tools',
        join: 'Join 10+ million users and create and inspire inspiration with 微鲤AI',
        startNow: 'Start Now',
    },
}
